"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
const useStyles = props => {
  const {
    pxToRem,
    setEndDirection
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    view = 'default'
  } = props;
  const ccBookMyBooksStyle = (0, _react.useMemo)(() => {
    const viewProps = () => {
      if (view === 'horizontal') {
        return {
          opacity: 1,
          bottom: pxToRem(-41)
        };
      }
      return {
        top: pxToRem(10)
      };
    };
    const deviceProps = () => {
      if (isMobileView) {
        return {
          opacity: 1
        };
      }
      return {};
    };
    const ccBookMyBooks = (0, _css.css)({
      position: 'absolute',
      width: pxToRem(64),
      height: pxToRem(64),
      display: 'flex',
      justifyContent: 'flex-end',
      transition: 'opacity 0.3s ease 0s',
      ...setEndDirection(10),
      ...viewProps(),
      ...deviceProps()
    });
    return {
      ccBookMyBooks
    };
  }, [isMobileView, pxToRem, setEndDirection, view]);
  return {
    'cc-Book__my-books': ccBookMyBooksStyle.ccBookMyBooks
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;